var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitToApp24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3.00016L20 3.00131C21.1 3.0014 21.9999 3.90148 21.9998 5.00148L21.9987 19.0015C21.9986 20.1015 21.0985 21.0014 19.9985 21.0013L5.99852 21.0002C4.88852 21.0001 3.9986 20.1 3.99869 19L3.99902 15L5.99902 15.0002L5.99869 19.0002L19.9987 19.0013L19.9998 5.00131L5.99984 5.00016L5.99951 9.00016L3.99951 9L3.99984 5C3.99993 3.9 4.89 3.00007 6 3.00016ZM12.4989 17.0007L11.089 15.5906L13.6692 13.0008L3.99918 13L3.99934 11L13.6693 11.0008L11.0896 8.41058L12.4997 7.0007L17.4993 12.0011L12.4989 17.0007Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitToApp24Px);
export default __webpack_public_path__ + "static/media/exit_to_app_24px.f6d1b052440392fe926effb8bbac5ceb.svg";
export { ForwardRef as ReactComponent };